export default {
  data() {
    return {
      sliderOptions: {
        slidesPerView: 1,
        spaceBetween: 88,
        speed: 600,
        cursor: 'grab',
        navigation: {
          nextEl: '.js-slider-next',
          prevEl: '.js-slider-prev',
        },
        breakpoints: {
          1639: {
            spaceBetween: 60,
          },
          1300: {
            spaceBetween: 48,
          },
          1160: {
            spaceBetween: 32,
          },
          920: {
            spaceBetween: 0,
          },
        },
      },
    }
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/lite-slider-block/component.js